import { cn } from "@/libs/utils";
import React from "react";

export default function Container({
  className = "",
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={"flex w-full justify-center"}>
      <div
        className={cn("mx-4 w-full max-w-screen-max laptop:mx-5", className)}
        {...rest}
      />
    </div>
  );
}
